/* eslint-disable react/prop-types */
import { Box, FormHelperText, InputLabel, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import styles from 'styles/globalStyle.module.scss';

const CustomInputBox = (props) => {
  const {
    control,
    label,
    name,
    errors,
    errorText,
    isDisabled,
    required,
    classes,
    flexDirection,
    placeholder,
    type,
    maxLength,
    regex,
    labelOff,
    ...rest
  } = props;

  const handleOnKeyPress = (e) => {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!regex?.test(keyValue)) {
      e.preventDefault();
    }
  };
  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({ field: { ref, ...field } }) => (
          <Box display="flex" gap={0.625} my={0.5} flexDirection={flexDirection} {...rest}>
            {!labelOff && (
              <InputLabel htmlFor={name}>
                {required && <span style={{ color: 'red' }}>*&nbsp;</span>}
                {label}
              </InputLabel>
            )}

            <TextField
              id={name}
              name={name}
              type={type}
              disabled={isDisabled ? true : false}
              // {...register(name)}
              {...field}
              classes={{ root: classes }}
              inputProps={{
                'data-testid': name,
                maxLength,
              }}
              onKeyPress={regex && handleOnKeyPress}
              onBlur={(e) => {
                field.onChange(e.target.value.trim());
              }}
              placeholder={placeholder}
              inputRef={ref}
            />
            {errors && (
              <FormHelperText gap={2} className={styles.customSelectError}>
                {' '}
                {errorText}
              </FormHelperText>
            )}
          </Box>
        )}
      />
    </>
  );
};

export default CustomInputBox;

CustomInputBox.propTypes = {
  control: PropTypes.instanceOf(Object),
  classes: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  errors: PropTypes.bool,
  isDisabled: PropTypes.bool,
  required: PropTypes.bool,

  errorText: PropTypes.string,
  label: PropTypes.string,
  flexDirection: PropTypes.string,
  placeholder: PropTypes.string,
  rest: PropTypes.instanceOf(Object),
  labelOff: PropTypes.bool,
};
CustomInputBox.defaultProps = {
  control: {},
  classes: '',
  name: '',
  type: 'text',
  label: '',
  errors: false,
  isDisabled: false,
  required: false,
  errorText: '',
  placeholder: '',
  flexDirection: 'row',
  rest: {},
  labelOff: false,
};
